//#region src/process/sandbox-server.ts
var READY_MARKER = "opencode server listening";
async function startOpencodeServerInSandbox(sandbox, options) {
	const command = `opencode serve --hostname=${options.hostname ?? "0.0.0.0"} --port=${options.port}`;
	const proc = await sandbox.process.spawn(command, {
		cwd: options.cwd,
		...options.env ? { env: options.env } : {},
		...options.signal ? { signal: options.signal } : {}
	});
	await waitForReady(proc, options.timeoutMs ?? 3e4);
	const channel = await sandbox.ports.connect(options.port);
	const headers = channel.headers ?? (channel.token ? { Authorization: `Bearer ${channel.token}` } : void 0);
	return {
		baseUrl: channel.url,
		...headers ? { headers } : {},
		dispose: () => proc.kill()
	};
}
function waitForReady(proc, timeoutMs) {
	return new Promise((resolve, reject) => {
		let stdout = "";
		let stderr = "";
		const state = { settled: false };
		const settle = (fn) => {
			if (state.settled) return;
			state.settled = true;
			clearTimeout(timer);
			fn();
		};
		const diagnostics = () => [stdout, stderr].map((s) => s.trim()).filter(Boolean).join("\n").slice(-500);
		const timer = setTimeout(() => settle(() => reject(/* @__PURE__ */ new Error(`opencode serve did not become ready within ${timeoutMs}ms${diagnostics() ? `: ${diagnostics()}` : ""}`))), timeoutMs);
		(async () => {
			try {
				for await (const chunk of proc.stderr) stderr += chunk;
			} catch {}
		})();
		(async () => {
			try {
				for await (const chunk of proc.stdout) {
					stdout += chunk;
					if (stdout.includes(READY_MARKER)) {
						settle(resolve);
						return;
					}
				}
				settle(() => reject(/* @__PURE__ */ new Error(`opencode serve exited before becoming ready${diagnostics() ? `: ${diagnostics()}` : " (no output)"}`)));
			} catch (error) {
				settle(() => reject(error));
			}
		})();
	});
}
//#endregion
export { startOpencodeServerInSandbox };

//# sourceMappingURL=sandbox-server.js.map